/* unplugin-vue-components disabled */import { render } from "./QuestionTplSelector.vue?vue&type=template&id=b2da65a0&scoped=true"
import script from "./QuestionTplSelector.vue?vue&type=script&lang=js"
export * from "./QuestionTplSelector.vue?vue&type=script&lang=js"

import "./QuestionTplSelector.vue?vue&type=style&index=0&id=b2da65a0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2da65a0"]])

export default __exports__